
const routes = {
  default: "/",
  home: "/home",
  // Add more as needed
};

export default routes;